import { Work } from "./work";
import { Expression } from "./expression";
import { Manifestation } from "./manifestation";
import { Item } from "./item";

export type SearchResult = Item & Manifestation & Expression & Work

export function isSearchResult(entity: any) {
    return 'federatedSchema' in entity
}

/*export function extractWorkFromSearchResult(searchResult: SearchResult): Work {
    
}*/